import gql from "graphql-tag";

export const Authentification = gql`
  mutation clientAuthenticate($input: ClientAuthenticateInput!) {
    clientAuthenticate(input: $input) {
      code
      message
      error
      data {
        jwToken {
          value
          expiration
        }
      }
    }
  }
`;

export const ResetPasswordMutation = gql`
  mutation clientForgotPassword($input: ClientAccountForgetPasswordInput!) {
    clientForgotPassword(input: $input) {
      message
      code
      error
      data
    }
  }
`;
// todo google authentification
export const ConnectionWithGoogleClient = gql`
  mutation clientConnectionWithGoogle($input: ClientGoogleLoginInput!) {
    clientConnectionWithGoogle(input: $input) {
      code
      message
      error
      data {
        token
        jwToken {
          value
          expiration
        }
      }
    }
  }
`;
